import logoAstar from "@assets/events-awards/ee/logo-astar.png";
import logoMasterCard from "@assets/events-awards/ee/logo-mastercard.png";
import logoPaiaFromcbre from "@assets/events-awards/ee/logo-paia-fromcbre.png";
import logoRajahTananAsia from "@assets/events-awards/ee/logo-r-tasia-tagline-rgb.png";
import logoRsm from "@assets/events-awards/ee/logo-rsm.png";
import logoEnterpriseSingapore from "@assets/events-awards/logo-enterprise-singapore.png";
import logoOCBC from "@assets/events-awards/logo-ocbc.png";
import logoBT from "@assets/logo-masthead.svg";
import Container from "@components/Container/Container";

/**
 * Component to render Organiser Details of EE on homepage
 */
const EEOrganiserDetails = (): React.ReactElement => {
  return (
    <Container
      rootClassName="font-public-sans text-gray-850"
      data-testis="ee-organiser-details-component"
    >
      <p className="pt-16 text-center">Presented by</p>

      <div className="flex flex-col justify-center px-3 pt-2 md:flex-row md:px-6 lg:items-start lg:px-12 lg:pb-8">
        <div className="flex flex-col items-center">
          <img
            src={logoOCBC}
            width={145}
            height={51}
            alt="The Business Times logo"
            className="my-6 mb-20 md:mb-0 md:mr-12"
          />
        </div>

        <div className="flex flex-col items-center justify-center">
          <img
            src={logoBT}
            width={260}
            height={45}
            alt="The Business Times logo"
            className="my-6 mt-7 lg:mt-9"
          />
        </div>
      </div>

      <div className="flex flex-col justify-center px-3 pt-8 md:px-6 lg:flex-row lg:items-start lg:px-0 lg:px-12 lg:pt-3">
        <div className="mt-4 flex flex-col items-center md:mt-0 lg:w-1/3">
          <p>Preferred payment solutions partner</p>

          <img
            src={logoMasterCard}
            width={80}
            height={57}
            alt="The Business Times logo"
            className="my-6"
          />
        </div>

        <div className="flex flex-col items-center lg:w-1/3">
          <p>Official auditor</p>
          <img
            src={logoRsm}
            width={100}
            height={43}
            alt="The Business Times logo"
            className="my-6 mt-10"
          />
        </div>

        <div className="flex flex-col items-center lg:w-1/3">
          <p>Official legal adviser</p>
          <img
            src={logoRajahTananAsia}
            width={100}
            height={83}
            alt="The Business Times logo"
            className="my-6 mt-10"
          />
        </div>
      </div>

      <p className="mt-6 text-center">Partners</p>

      <div className="flex flex-col justify-center px-3 pt-8 md:px-6 md:pt-4 lg:flex-row lg:items-start lg:px-12 lg:pb-14 lg:pl-20 lg:pt-8">
        <div className="flex flex-col items-center lg:w-1/3">
          <img
            src={logoAstar}
            width={160}
            height={51}
            alt="The Business Times logo"
            className="my-4"
          />
        </div>

        <div className="flex flex-col items-center lg:w-1/3">
          <img
            src={logoEnterpriseSingapore}
            width={127}
            height={45}
            alt="The Business Times logo"
            className="my-6 ml-10"
          />
        </div>

        <div className="flex flex-col items-center lg:w-1/3">
          <img
            src={logoPaiaFromcbre}
            width={82}
            height={82}
            alt="The Business Times logo"
            className="my-6 mt-0"
          />
        </div>
      </div>
    </Container>
  );
};

export default EEOrganiserDetails;
